import { dehydrate } from '@tanstack/react-query';
import type { QueryClient } from '@tanstack/react-query';

import { Channel } from '@annunciate/core/dist/models';
import { useQueryContextStore } from '@annunciate/core/dist/store';
import { CHANNEL_SETTINGS_GET, request, ChannelSettingsResponse } from '@annunciate/query';
import Config from '@annunciate/core/dist/utils/config';

import { client } from '../queryClient';

type WithSetupCallback = (ctx: any, client: QueryClient) => Promise<any> | any;

export interface WithSetupProps extends Record<string, any>{
  channelSettings: Channel['settings'],
  dehydratedState: any;
}

export const withSetup = (
  callback: WithSetupCallback = () => {},
) => async (ctx: any): Promise<WithSetupProps> => {
  // configure the query context endpoint
  useQueryContextStore.setState({ endpoint: Config.API_HOST });

  // prefetch navigation
  const navVariables = { id: Config.APP_CHANNEL };
  const getNavData = async () => {
    return request({
      query: CHANNEL_SETTINGS_GET,
      variables: navVariables,
    });
  };
  const queryKey = ['channel:settings', navVariables];
  await client.prefetchQuery({
    queryKey,
    queryFn: getNavData,
  });
  const data: ChannelSettingsResponse | undefined
    = client.getQueryData(queryKey);

  const result = (await callback(ctx, client)) || {};
  return {
    ...result,
    channelSettings: data?.channel?.settings || {},
    dehydratedState: dehydrate(client),
  };
}
